import React from "react"
import { Helmet } from "react-helmet"
import BaseController from "../base-controller"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { defineCustomElements as deckDeckGoHighlightElement } from "@deckdeckgo/highlight-code/dist/loader";
deckDeckGoHighlightElement();

const baseUrl = 'https://popupfox.com';
export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { mdx } = data // data.mdx holds your post data
  const { frontmatter, body } = mdx
  const image = frontmatter?.image?.childImageSharp?.gatsbyImageData?.images?.fallback?.src;
  return (
    <BaseController>
      <Helmet>
        <title>{frontmatter.title}</title>
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="generator" content="Popupfox" />
        <meta name="description" content={frontmatter.description} />
        <meta name="title" content={frontmatter.title} />
        <meta name="twitter:card" property="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" property="twitter:title" content={frontmatter.title} />
        <meta name="twitter:description" property="twitter:description" content={frontmatter.description} />
        <meta name="twitter:url" property="twitter:url" content={`${baseUrl}${frontmatter.slug}`} />
        <meta property="og:site_name" content="Popupfox" />
        <meta property="og:title" content={frontmatter.title} />
        <meta property="og:type" content="article" />
        <meta property="og:url" content={`${baseUrl}${frontmatter.slug}`} />
        <meta property="og:description" content={frontmatter.description} />
        <meta property="article:author" content="https://facebook.com/popupfox" />
        <meta property="keywords" content={frontmatter.keywords} />
        {image && <meta property="og:image" content={`${baseUrl}${image}`} />}
        {image && <meta name="twitter:image" property="twitter:image" content={`${baseUrl}${image}`} />}
      </Helmet>
      <section>
        <div class="container">
          <div class="row justify-content-center">
              <div class="col-md-12 col-lg-12">
                <MDXRenderer>{body}</MDXRenderer>
              </div>
          </div>
        </div>
      </section>
    </BaseController>
  )
}

export const pageQuery = graphql`
  query og($id: String!) {
    mdx(id: { eq: $id }) {
      body
      frontmatter {
        slug
        title
        date
        description
        keywords
        image {
          absolutePath
          base
          childImageSharp {
            gatsbyImageData(
              width: 1024
              blurredOptions: {width: 100}
              placeholder: BLURRED
              transformOptions: {cropFocus: CENTER}
            )
          }
        }
      }
    }
  }
  `